module.exports = __webpack_public_path__ + "static/media/List_PIPE.5b88f304.mp3";